import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { GetTimeResponse } from '../api/hub-responses/get-time-response';
import { container } from './container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from './container/service-ids';
import { FlagNames } from './feature-flags/flag-names';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export class ServerTime {
    private diff: number|null = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private syncInProgress: Promise<any>;

    public async getTime(): Promise<number> {
        if (this.diff === null && !this.syncInProgress) {
            this.syncInProgress = this.getDiff();
            await this.syncInProgress;
        }

        if (this.syncInProgress) {
            await this.syncInProgress;
        }

        const diff = this.diff ? this.diff : 0;
        return Math.floor(Date.now() / 1000) + diff;
    }

    private async getDiff() {
        const requestStartTs = Math.floor(Date.now() / 1000);
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const isHubApiEnabled = ffLoader.get(FlagNames.SITE_HUB_API_ENABLED)?.isOn();

        if (!isHubApiEnabled) {
            this.syncInProgress = HubJsonRpcRequest.makeRequest<GetTimeResponse, undefined>(
                HubApiMethods.GET_SERVER_TIME,
                undefined,
                window.app.deviceIdentifier
            );
        } else {
            const hubApi = getHubApi();
            this.syncInProgress = hubApi.getServerTime(window.app.deviceIdentifier);
        }

        const serverTime = await this.syncInProgress
            .then((response) => {
                if (response?.time) {
                    return response.time;
                }

                return null;
            })
            .catch(()=>{
                return null;
            });
        this.syncInProgress = void 0;
        if (serverTime !== null) {
            this.diff = serverTime - requestStartTs;
        }
    }
}
